import $ from "jquery"
import AbstractVendor from "@/business-components/sale/callcenter/AbstractVendor"
import _ from "lodash"
import message from "@/utils/message"
import modal from "@/utils/modal"
import beacon from "@/common/report-beacon"
import events from "@/common/beacon-events"

const QiDianDialDirectionMap = {
  1: "DIAL_DIRECTION_IN",
  2: "DIAL_DIRECTION_OUT",
}

const QiDianTraceMap = {
  CALLING_STATUS_OUT_AGENT_ALTER: {
    CallStatus: 2,
    CallDirection: 2,
  }, //"外呼坐席振铃事件"
  CALLING_STATUS_OUT_CUSTOMER_CONNECT: {
    CallStatus: 3,
    CallDirection: 2,
  }, //"外呼坐席接通事件"
  CALLING_STATUS_AGENT_DISCONNECT: {
    CallStatus: 4,
    CallDirection: 2,
  }, //"坐席挂断事件"
  CALLING_STATUS_CUSTOMER_DISCONNECT: {
    CallStatus: 4,
    CallDirection: 1,
  }, //"客户挂断事件"
}

const QIDIAN_TRACE_MAP = {
  CONNECT: "connect", // 前端自定义状态，拨打电话后马上切换到这个状态
  CALLING: "calling", // 来电
  ONLINE: "online", // 已接通
  OVER: "over", // 通话结束
}

const defaultCallerNumber = null

class QiDian extends AbstractVendor {
  constructor(agent, info = {}) {
    super()
    this.name = "CALL_CENTER_VENDOR_QIDIAN"
    this.agent = agent
    this.dialStatus = {}
    this.ticket = info.ticket
    this.kfext = info.kfext
    this.appId = info.appId
    this.seatPreferredPhone = info.seatPreferredPhone
    this.mode = info.seatPreferredPhone === "SEAT_PREFERRED_PHONE_SIP" ? "webrtc" : "sip"
    this.currentNumber = '系统匹配';
  }

  bind({ agencyId, userId, callCenter }) {
    this.agencyId = agencyId
    this.userId = userId
  }

  onDialOut(callback) {
    this.dialOutCallback = callback
  }

  onUpdateStatus(callback) {
    this.onUpdateStatusCallback = callback
  }

  onDialStatusUpdate(callback) {
    this.onDailStatusUpdateCallback = callback
  }

  onDialIn(callback) {
    this._onDialIn = callback
  }

  renderErrModal = (err = {}) => {
    return <div className="call-err-modal">
      <p className="err-msg">{err.msg}</p>
      <br />
      <p>code: {err.code}</p>
      <p>errcode: {err.errcode}</p>
      <p>errmsg: {err.errmsg}</p>
    </div>
  }

  /**
   * @description: 移除企点原本操作按钮dom，重写外呼按钮逻辑，点击调用dialOutCallback方法进行呼叫
   */
  handleCallBtn = () => {
    const domA = document.createElement("a")
    const svg = `<svg viewBox="0 0 34 34"><use xlink:href="#call_answer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" id="call_answer">
          <g>
            <circle class="st0" cx="17" cy="17" r="17"></circle>
          </g>
          <path class="st1" d="M13.4,20.5c4.4,4.4,9.8,4.5,10.8,4.5l0.7-0.7c0,0,0-1.8,0-2.5c0-1-0.3-1.3-0.3-1.3l-4.5-0.9
            c0,0-0.4-0.2-0.8,0.5c-0.2,0.4-0.9,1.6-0.9,1.6c-0.8-0.3-2.3-0.9-3.7-2.4c-1.4-1.4-2.1-2.9-2.4-3.7c0,0,1.2-0.7,1.6-0.9
            c0.7-0.4,0.5-0.8,0.5-0.8l-0.9-4.5c0,0-0.3-0.3-1.3-0.3c-0.7,0-2.5,0-2.5,0L9,9.7C9,10.7,9,16.2,13.4,20.5z"></path>
          </svg>
      </use>
    </svg>`
    domA.innerHTML = svg
    domA.style.cssText = "width: 35px;height: 35px;position: absolute;right: 10px;top: 50%;margin-top: -17px;color: #00d100;cursor: pointer;"
    const iframe = document.querySelector("#qd-agentbar iframe").contentWindow
    const btn = iframe.document.querySelector(".call")
    btn.remove()
    const agentbar = iframe.document.querySelector(".agentbar")
    agentbar.appendChild(domA)
    // btn.className += "is-disable"
    const _this = this
    const makeCall = (number, extraParams, extraResp, params = {}) => {
      this.dialStatus.number = number
      this.dialStatus.params = Object.assign({}, params, extraParams)
      this.dialStatus.resp = extraResp || {}

      return new Promise((resolve, reject) => {
        this.agent.agentMakeCall({
          phone_number: `+86${number}`, // 必填，手机号码，E164格式
          success: function (res) {
            console.log(res)
            if (res.code === 0) {
              resolve(res)
            } else {
              reject(res)
            }
          },
          fail: (err) => {
            beacon.onUserAction(events.callCenter.key, {
              status: "fail",
              code: err.code,
              message: err.msg,
              mode: _this.mode,
              appId: _this.appId,
              kfext: _this.kfext,
              ticket: _this.ticket,
            })
            console.log(err, "呼叫失败")
            const errMsg = this.renderErrModal(err)
            modal.error(errMsg)
          },
        })
      })
    }
    const click = _.debounce((e) => {
      e.stopImmediatePropagation()
      const number = iframe.document.querySelector(".input .number").value
      if (!number) return
      let precheckParam = {
        mode: "manual", // 手动触发
        isIntellectCall: false,
        calleeNumber: number,
        makeCall: makeCall,
        callerNumber: defaultCallerNumber,
      }
      this.dialOutCallback(precheckParam)
    }, 2500, { leading: true, trailing: false })

    domA.addEventListener("click", click, false)

    // 回车拨打电话
    const inputDom = iframe.document.querySelector(".input .number")
    inputDom.onkeypress = (e) => {
      if (e.charCode == 13) {
        click(e)
      }
    }
  }

  login() {
    const qdAgentbarEle = document.createElement("div")
    qdAgentbarEle.id = "qd-agentbar"
    document.querySelector("body").appendChild(qdAgentbarEle)

    const qdAgentbarIconEle = document.createElement("i")
    qdAgentbarIconEle.id = "qd-agentbar-icon"
    qdAgentbarIconEle.className = "fa fa-phone-square qn-icon"

    document.querySelector("body").appendChild(qdAgentbarIconEle)

    qdAgentbarIconEle.addEventListener("click", (e) => {
      if (qdAgentbarEle.style.width === "700px") {
        qdAgentbarEle.style.width = "0"
        qdAgentbarEle.style.opacity = "0"
      } else {
        qdAgentbarEle.style.width = "700px"
        qdAgentbarEle.style.opacity = "1"
      }
    })

    const agent = this.agent

    agent.config({
      mode: this.mode, // 登录模式，默认client企点客户端 client/webrtc/sip
      version: 2, // 1 显示工号信息 2 使用openid信息替换工号 默认 1
      el: "#qd-agentbar", // 要渲染出agentbar的dom节点
      appId: this.appId, // 必填，应用唯一标识
      kfext: this.kfext, // 必填，本次登录对应企点的工号
      ticket: this.ticket, // 必填，js_api_ticket
      debug: false,
      success: (res) => {
        beacon.onUserAction(events.callCenter.key, {
          status: "success",
          mode: this.mode,
          appId: this.appId,
          kfext: this.kfext,
          ticket: this.ticket,
        })
        this.onUpdateStatusCallback(true, res)
        qdAgentbarIconEle.classList.add("qd-login")
        this.handleCallBtn()
        qd.on("disconnect", () => {
          // 事件在连接断开时触发，如被踢下线或其他原因socket被断开
          qdAgentbarIconEle.classList.remove("qd-login")
        })
        agent.on("ticketExpired", (e, res) => {
          $.get("/ags/call-center/jsticket").then((res) => {
            if (res.code === 0 && res.data.ticket) {
              qdAgentbarIconEle.classList.add("qd-login")
              agent.goon({ ticket: res.data.ticket });
            }
          })
        })

        qd.on('currentSwitchboardNumber.change', (e, number) => {
          this.currentNumber = number || '系统匹配';
        });

        if (this.seatPreferredPhone === "SEAT_PREFERRED_PHONE_MOBILE") {
          agent.changeAnswerType({
            answer_type: 1, // 接听方式标记值（1: pstn接听, 2: voip接听，3: 关闭接听）
          });
        } else {
          agent.changeAnswerType({
            answer_type: 2, // 接听方式标记值（1: pstn接听, 2: voip接听，3: 关闭接听）
          });
        }

        agent.on("statusChange", (e, res) => {
          _.forEach(QiDianTraceMap, (value, key) => {
            if (_.isEqual(value, { CallStatus: res.CallStatus, CallDirection: res.CallDirection })) {
              this.dialStatus.sessionId = res.CallId
              this.dialStatus.dialDirection = QiDianDialDirectionMap[res.CallDirection]
              this.dialStatus.callingStatus = key
              this.onDailStatusUpdateCallback(this.dialStatus)
            }
          });
        });

        agent.on("stateChange", (e, state) => {
          if (state === QIDIAN_TRACE_MAP.CALLING) {
            const res = agent.getState()
            if (res.nextState.CallDirection === 1) {
              // 电话呼入
              this._onDialIn({ ...res.nextState, isAnswered: false })
            }
          }
          if (state === QIDIAN_TRACE_MAP.ONLINE) {
            const res = agent.getState()
            if (res.nextState.CallDirection === 1) {
              // 电话接通
              this._onDialIn({ ...res.nextState, isAnswered: true })
            }
          }
        })
      },
      fail: (err) => {
        beacon.onUserAction(events.callCenter.key, {
          status: "fail",
          code: err.code,
          message: err.message,
          mode: this.mode,
          appId: this.appId,
          kfext: this.kfext,
          ticket: this.ticket,
        })
        this.onUpdateStatusCallback(false, err)
        modal.error("企点外呼初始化失败: " + err.message + ",错误code: " + err.code)
      },
    })
  }

  dialOut(number, params) {
    const _this = this
    const makeCall = (number, extraParams, extraResp) => {
      this.dialStatus.number = number
      this.dialStatus.params = Object.assign({}, params, extraParams)
      this.dialStatus.resp = extraResp || {}

      return new Promise((resolve, reject) => {
        this.agent.agentMakeCall({
          phone_number: `+86${number}`, // 必填，手机号码，E164格式
          success: function (res) {
            console.log(res)
            if (res.code === 0) {
              resolve(res)
            } else {
              reject(res)
            }
          },
          fail: (err) => {
            beacon.onUserAction(events.callCenter.key, {
              status: "fail",
              code: err.code,
              message: err.msg,
              mode: _this.mode,
              appId: _this.appId,
              kfext: _this.kfext,
              ticket: _this.ticket,
            })
            console.log(err, "呼叫失败")
            const errMsg = this.renderErrModal(err)
            modal.error(errMsg)
          },
        })
      })
    }

    let precheckParam = {
      mode: "program", // 程序触发
      isIntellectCall: false,
      calleeNumber: number,
      makeCall: makeCall,
      callerNumber: defaultCallerNumber,
      ...params,
    }

    // 回调 CallCenter，由其判断是否需要继续呼叫
    const precheck = this.dialOutCallback ? this.dialOutCallback(precheckParam) : Promise.resolve()

    return precheck
  }

  dialIn() {
    this.agent.answer({
      success: function (res) {
        console.log(".....接听")
      },
      fail: (err) => {
        console.log(err, ".....接听失败")
        modal.error(err?.msg + ", 错误code: " + err?.code)
      },
    })
  }
}

export default QiDian
